import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BorderedDropdownIconComponent } from '../../../bordered-dropdown-icon/bordered-dropdown-icon.component';

/**
 * Todo: delete this component in future
 *@deprecated - use SidebarHeaderComponent instead
 */
@Component({
  selector: 'app-commitment-sidebar-title',
  templateUrl: './commitment-sidebar-title.component.html',
  styleUrls: ['./commitment-sidebar-title.component.scss'],
  imports: [BorderedDropdownIconComponent],
})
export class CommitmentSidebarTitleComponent {
  @Input() title: string;
  @Input() showBackButton = false;
  @Output() goBack = new EventEmitter<void>();

  onBack() {
    this.goBack.emit();
  }
}
